<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作流</el-breadcrumb-item>
          <el-breadcrumb-item>图片展示</el-breadcrumb-item>
          <el-breadcrumb-item>图片展示列表</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>
          图片展示
        </h4>
        <div v-if="false"
             class="picsearch">
          <el-input v-model="search"
                    placeholder="请输入关键字"></el-input>
          <div class="btn">
            <img src="@/assets/workflow/search.png"
                 alt="">
            <p>搜索</p>
          </div>
        </div>
        <!-- <p @click="changeUserForm">+创建筛选任务</p> -->
      </div>

      <div class="tabsbody">
        <div style="height:650px;width:100%;display: flex;justify-content: space-between;position: relative;">

          <div class="column">
            <div class="columnhead">
              <div style="display: flex;align-items: center;">
                <img src="@/assets/workflow/column.png"
                     alt="">
                <p>栏目</p>
              </div>
              <div @click="chooseRecommend"
                   :class="[isRecommend ? 'recommend active':'recommend']">
                <img style="margin-right:5px;"
                     src="@/assets/workflow/jian.png"
                     alt="">
                <!-- <div>推荐</div> -->
              </div>
            </div>
            <div v-loading="columnRefresh"
                 class="columnbody">

              <el-tree :data="data"
                       ref="vuetree"
                       highlight-current
                       check-strictly
                       node-key="id"
                       :expand-on-click-node="false"
                       default-expand-all
                       :props="defaultProps"
                       @node-click="handleNodeClick">
              </el-tree>
            </div>
          </div>

          <div class="table"
               v-loading="isRefresh">
 
            <picshowtable v-if="!isRecommend"
                          :tableData='picShowList'
                          @reCallClick='reCallClick'
                          @releaseClick='releaseClick'
                          @removeClick='removeClick'
                          @changeClick='changeClick'
                          @recommendClick='recommendClick'
                          @notRecommendClick='notRecommendClick'
                          @seePic='seePic'></picshowtable>
            <picshowpicshowrectabletable v-if="isRecommend"
                                         :tableData='picShowList'
                                         @reCallClick='reCallClick'
                                         @releaseClick='releaseClick'
                                         @removeClick='removeClick'
                                         @changeClick='changeClick'
                                         @notRecommendClick='notRecommendClick'
                                         @sortClick='sortClick'
                                         @seePic='seePic'></picshowpicshowrectabletable>

            <div class="pagination">
              <el-pagination @size-change="handleSizeChange"
                             @current-change="handleCurrentChange"
                             :current-page.sync="currentPage"
                             :page-size="pageSize"
                             layout="prev, pager, next"
                             :total="total"></el-pagination>
            </div>
            
          </div>


          <div class="search">
            <!-- 关键字 -->
            <div class="coninput">
              <h5 style="margin-right:10px;">关键字:</h5>
              <el-input class="elinput"
                        v-model="selectInput"
                        style="width:150px"
                        placeholder="请输入关键字"></el-input>
            </div>

            <div class="coninput">
              <h5 style="margin-right:10px;">入库时间:</h5>
              <el-date-picker v-model="warehousingTime"
                              type="daterange"
                              align="center"
                              value-format="timestamp"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"></el-date-picker>
              <!-- <i class="dateicon el-icon-date"></i> -->
            </div>

            <div class="coninput">
              <h5 style="margin-right:10px;">发布状态:</h5>
              <el-select
                v-model="statusvalue"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>

            <div @click="searchclick" class="btn">
              搜索
            </div>
          </div>
        </div>
      </div>

    </div>

    <el-dialog :visible.sync="sortVisible"
               width="30%"
               :before-close="handleClose">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>排序</div>
      </div>
      <div style="width:100%;display:flex;padding-left:10px;align-items: center;">
        <el-input-number v-model="sort"
                         :min='0'
                         :step="1"
                         @change="toInteger"
                         controls-position="right"></el-input-number>
        <p style="margin-left:10px;">数字越大越靠前~</p>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="picSort">确 定</el-button>
      </span>
    </el-dialog>

    <picView v-if="picdialogVisible"
             :dialogVisible="picdialogVisible"
             @handleClose="handleClosepic"
             :passChoose='passChoose'
             :picList='picList'></picView>

  </div>
</template>

<script>
import { picshowtable, picshowpicshowrectabletable } from "@/components/index";
import picView from "./components/picView/index";
import { mapGetters } from "vuex";
import { picPrefix } from "@/constants/piccommon";
import {
  listWebsiteColumn,
  listWebsiteShowInfo,
  updateWebsiteShowInfo,
  deleteWebsiteShowInfo,
  getWebsiteShowInfo
} from "@/api/website";
import { getUser } from '@/api/user'
import { getPictures } from '@/api/picture'
import { getDate, formatConversion } from "@/plugins/getdate";
import QRCode from 'qrcodejs2'  // 引入qrcode
import { powersObj } from "@/constants/powers";
import { Pagination } from 'vant';
export default {
  components: {
    picshowtable, picshowpicshowrectabletable,picView
  },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {
      activeName: '0',
      isRefresh: false,
      columnRefresh: false,
      //权限
      powersObj,
      currentPage: 1,
      pageSize: 6,
      total: 0,
      timeInt: null,

      columnId: 0,

      isRecommend: false,

      picShowList: [],

      //搜索字段
      search: '',

      //栏目列表
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },

      //储存排序的信息
      ruleform: null,
      sortVisible: false,
      sort: 0,



      //查看图片
      picdialogVisible:false,
      passChoose:{},
      picList:[],


      warehousingTime:[],
      selectInput:'',
      statusList:[
        {
          id:'-1',
          name:'不限'
        },{
          id:'0',
          name:'草稿'
        },{
          id:'1',
          name:'已发布'
        },{
          id:'2',
          name:'定时发布'
        },
      ],
      statusvalue:''
    };
  },
  methods: {

    searchclick(){
      this.currentPage = 1
      let timeStart = '',timeEnd = ''
      if (this.warehousingTime) {
        if (this.warehousingTime[0] == this.warehousingTime[1]) {
          this.warehousingTime[0] = this.warehousingTime[0];
          this.warehousingTime[1] = this.warehousingTime[1] + 86400000;
        }
        if (this.warehousingTime[0]) {
          timeStart = this.warehousingTime[0] / 1000;
          timeEnd = this.warehousingTime[1] / 1000;
        }
      } else {
        timeStart = "";
        timeEnd = "";
      }
      let val = {
        page: this.currentPage - 1,
        pageSize: this.pageSize,
        columnId: this.columnId,
        status :this.statusvalue,
        keyword : this.selectInput,
        timeStart: timeStart,
        timeEnd: timeEnd
      }
      this.listWebsiteShowInfoAsync(val)
    },

    //查看图片
    async seePic(e){
      if(e.row.pictureIds <= 0){
        this.$message.warning('暂无图片')
        return false;
      }
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)
      let {status,data,message,errors} = await getPictures({ids:e.row.pictureIds})
      if(status){
        for (let i = 0; i < data.length; i++) {
          data[i].myId = i
          data[i].picThumbW1080 = picPrefix + data[i].fileInfo.picThumbW1080
          data[i].src = picPrefix + data[i].fileInfo.picThumbWh160
          data[i].isLove = false
        }

        this.picList = data
        if (picLoveArray) {
            for (let i = 0; i < picLoveArray.length; i++) {
              for (let j = 0; j < this.picList.length; j++) {
                if (picLoveArray[i].id === this.picList[j].id) {
                  this.picList[j].isLove = true
                  continue;
                }
              }
            }
        }
        console.log('123',this.picList,picLoveArray);
        this.passChoose = data[0]
        this.picdialogVisible = true
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    handleClosepic(){
      this.picdialogVisible = false
    },

    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (value) {
      this.currentPage = value;
      let timeStart = '',timeEnd = ''
      if (this.warehousingTime) {
        if (this.warehousingTime[0] == this.warehousingTime[1]) {
          this.warehousingTime[0] = this.warehousingTime[0];
          this.warehousingTime[1] = this.warehousingTime[1] + 86400000;
        }
        if (this.warehousingTime[0]) {
          timeStart = this.warehousingTime[0] / 1000;
          timeEnd = this.warehousingTime[1] / 1000;
        }
      } else {
        timeStart = "";
        timeEnd = "";
      }
      let parmas = {
        page: value - 1,
        status :this.status,
        keyword : this.selectInput,
        status :this.statusvalue,
        timeStart: timeStart,
        timeEnd: timeEnd
      }
      if(this.isRecommend){
        parmas.pageSize = 6
        parmas.isRecommend = 1
      }else{
        parmas.pageSize = 6
        parmas.columnId = this.columnId
      }
      this.listWebsiteShowInfoAsync(parmas)
    },


    //排序相关
    handleClose () {
      this.sortVisible = false
      this.sort = ''
    },
    sortClick (val) {
      this.ruleform = val.row
      this.sort = parseInt(this.ruleform.sort)
      this.sortVisible = true
    },
    toInteger () {
      let reg = /^[0-9]+$/
      if (!reg.test(this.sort)) {
        // 用以在dom渲染挂载后重新触发dom渲染挂载
        this.$nextTick(() => {
          this.sort = parseInt(this.sort)
        })
      }
    },
    async picSort () {
      if (this.sort) {
        this.sortVisible = false
        this.ruleform.sort = this.sort
        // console.log(this.ruleform);
        let { status, data, message, errors } = await updateWebsiteShowInfo(this.ruleform);
        if (status) {
          this.$message.success('修改成功！')
          this.listWebsiteShowInfoAsync({
            page: this.currentPage - 1,
            pageSize: this.pageSize,
            isRecommend: 1
          })
        } else {
          let errortext = ''
          for (const key in errors) {
            errortext += errors[key]
          }
          this.$message.error({ message: message + errortext });
        }

      } else {
        this.$message.warning('请填写！')
      }

    },



    //选择栏目
    handleNodeClick (data, node) {
      this.isRecommend = false
      this.selectInput = ''
      this.warehousingTime = []
      this.statusvalue = ''
      if (node.level == 2) {
        this.$refs['vuetree'].setCurrentKey(data.id)
        this.columnId = data.id
        this.listWebsiteShowInfoAsync({
          page: this.currentPage - 1,
          pageSize: this.pageSize,
          columnId: data.id
        })
      } else {
        this.$refs['vuetree'].setCurrentKey(null)
      }

    },

    //选择推荐
    chooseRecommend () {
      this.isRecommend = true
      this.selectInput = ''
      this.warehousingTime = []
      this.statusvalue = ''
      if (this.currentPage == 0) {
        this.currentPage = 1
      }
      this.listWebsiteShowInfoAsync({
        page: this.currentPage - 1,
        pageSize: 9,
        isRecommend: 1
      })
      this.$refs['vuetree'].setCurrentKey(null)
    },

    // 表格操作

    //删除
    removeClick (val) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.deleteWebsiteShowInfoAsync(val.row.id)
        })
    },
    //撤回
    reCallClick (val) {
      this.$confirm("确认撤回吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          let parmas = val.row
          parmas.status = 0
          this.updateWebsiteShowInfoAsync(parmas)
        })
    },
    //发布
    releaseClick (val) {
      this.$confirm("确认发布吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          let parmas = val.row
          parmas.status = 1
          this.updateWebsiteShowInfoAsync(parmas)
        })
    },
    //修改
    changeClick (val) {
      this.$router.push({
        path: '/shareAndPush/push/show',
        query: {
          name: '站点发布',
          changeId: val.row.id,
          isChange: true,
          actName: val.row.author
        }
      })
    },

    //推荐
    async recommendClick (val) {
      let { status, data, message, pagination, errors } = await listWebsiteShowInfo({
        page: this.currentPage - 1,
        pageSize: this.pageSize,
        isRecommend: 1
      })
      if (status) {
        if (pagination.total < 9) {
          this.$confirm("确认推荐吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
          })
            .then(async () => {
              let parmas = val.row
              parmas.isRecommend = 1
              await this.updateWebsiteShowInfoAsync(parmas)
            })
        } else {
          this.$message.warning('推荐已达到上线！')
        }
      }

    },
    //取消推荐
    notRecommendClick (val) {
      this.$confirm("确认取消推荐吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          let parmas = val.row
          parmas.isRecommend = 0
          this.updateWebsiteShowInfoAsync(parmas, val.isrecommend)
        })
    },






    //刷新表格
    refresh () {
      this.isRefresh = true;
      this.currentPage = 0
      this.listWebsiteShowInfoAsync({
        page: this.currentPage,
        pageSize: this.pageSize,
        columnId: this.columnId
      })
      setTimeout(() => {
        this.isRefresh = false;
      }, 888);
    },

    //删除
    async deleteWebsiteShowInfoAsync (val) {
      let { status, data, message, errors } = await deleteWebsiteShowInfo(
        val
      );
      if (status) {
        this.$message.success('删除成功！')
        this.listWebsiteShowInfoAsync({
          page: this.currentPage - 1,
          pageSize: this.pageSize,
          columnId: this.columnId
        })
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //撤回/发布
    async updateWebsiteShowInfoAsync (val, flag) {
      let { status, data, message, errors } = await updateWebsiteShowInfo(
        val
      );
      if (status) {
        this.$message.success('修改成功！')
        let val
        if (flag) {
          val = {
            page: this.currentPage == 0 ? this.currentPage: this.currentPage - 1,
            pageSize: this.pageSize,
            isRecommend: 1
          }
        } else {
          val = {
            page: this.currentPage == 0 ? this.currentPage: this.currentPage - 1,
            pageSize: this.pageSize,
            columnId: this.columnId
          }
        }
        this.listWebsiteShowInfoAsync(val)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


    //获取信息列表
    async listWebsiteShowInfoAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listWebsiteShowInfo(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].updateAt) {
            data[i].updateAtMY = formatConversion(data[i].updateAt.toString())
          }
          data[i].createAtMY = formatConversion(data[i].createAt.toString())

          data[i].picLength = data[i].pictureIds.split(',').length

          if (data[i].createUid !== 0) {
            let userInfo = await getUser(data[i].createUid)
            data[i].createName = userInfo.data.name
          } else {
            data[i].createName = '暂无'
          }

        }

        this.picShowList = data

        this.total = pagination.total
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
      this.isRefresh = false
    },
    //获取用户列表
    async listCheckUserAsync (val) {
      let { status, data, message, pagination } = await listCheckUser(
        val
      );
      if (status) {
        this.exaList = []
        for (let i = 0; i < data.length; i++) {
          let userInfo = await getUser(data[i].uid)
          if (userInfo.status) {
            if (userInfo.data.status == 1) {
              this.exaList.push({
                value: userInfo.data.id,
                label: userInfo.data.name,
                mobile: userInfo.data.mobile,
                email: userInfo.data.email,
              })
            }

          }



        }
      }
    },

    //获取频道和栏目类别
    async listWebsiteColumnAsync (val) {
      this.columnRefresh = true
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listWebsiteColumn(val);
      if (status) {
        this.data = []
        for (let i = 0; i < data.length; i++) {
          this.data.push({
            id: data[i].id,
            label: data[i].name,
            children: []
          })
        }
        for (let i = 0; i < this.data.length; i++) {
          let childVal = {
            page: 0,
            pageSize: 50,
            parentId: this.data[i].id
          }
          let dataChildren = await listWebsiteColumn(childVal);
          if (dataChildren.data.length > 0) {
            for (let j = 0; j < dataChildren.data.length; j++) {
              this.data[i].children.push({
                id: dataChildren.data[j].id,
                label: dataChildren.data[j].name
              })

            }

          }

        }

        let firstId = 0
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].children.length > 0) {
            firstId = this.data[i].children[0].id
            // console.log(firstId);
            break
          }

        }
        if (firstId == 0) {
          this.$message.warning('请新建栏目！')
          this.isRefresh = false
        } else {
          this.columnId = firstId
          this.$refs['vuetree'].setCurrentKey(this.columnId)

          this.listWebsiteShowInfoAsync({
            page: this.currentPage - 1,
            pageSize: this.pageSize,
            columnId: this.columnId
          })
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
      this.columnRefresh = false

    },

  },
  created () {
    let val = {
      page: 0,
      pageSize: 50,
      parentId: 0
    }
    this.listWebsiteColumnAsync(val)



    // this.handleCurrentChange(this.currentPage);
    // this.timeInt = setInterval(() => {
    //   this.handleCurrentChange(this.currentPage);
    // }, 90000);
  },
  beforeDestroy () {
    // 组件销毁前调用
    // clearTimeout(this.timeInt);
  },
  mounted () { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./picshow.scss";
@import "@/constants/elHeader.scss";
.pagination {
  position: absolute;
  right: 30px;
  bottom: 30px;
}

::v-deep .el-tree-node > .el-tree-node__content {
  background: #f5f5f5 !important;
  border-radius: 5px;
  // font-weight: bold;
  color: #242433;
  line-height: 32px;
  height: auto;
  font-size: 16px;
  margin: 5px 0;
  border: 2px dotted transparent !important;
  .el-tree-node__label {
    font-size: 16px;
  }
}
::v-deep .el-tree-node__children > .el-tree-node .el-tree-node__content {
  background: rgba(243, 248, 255, 1) !important;
  border-radius: 5px;
  font-weight: 400;
  line-height: 32px;
  height: auto;
  color: #7c7c8a;
  transition: 0.3s;
  margin: 5px 0;
  // margin-top: 0 !important;
  &:hover {
    background: RGBA(221, 235, 255, 1) !important;
  }
  .el-tree-node__label {
    font-size: 14px;
  }
}

::v-deep .is-current > .el-tree-node__content {
  border: 2px solid rgb(182, 182, 182) !important;
}
</style>
